<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <!--  仕入先発注予定 -->
      <div class="annualOrdersForm">
        <t-form label-position="right" label-width="100px">
          <t-row
            type="flex"
            justify="left
          "
          >
            <t-col :span="16">
              <t-form-item
                :label="$t('resource.CUS_M_ORDER_AMOUNT.PERIOD')"
                class="marginBottom"
              >
                <t-select class="select-year-width" v-model="period.startYear">
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select class="select-year-width" v-model="period.startMonth">
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
                <span>&nbsp;&nbsp;～&nbsp;&nbsp;</span>
                <t-select class="select-year-width" v-model="period.endYear">
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select class="select-year-width" v-model="period.endMonth">
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <t-col :span="4" class="right">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="button_common_search marginRight"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>{{ $t("resource.sys.search") }}
              </t-button>
            </t-col>

            <t-col :span="4" class="right">
              <!-- 社内製造 -->
              <t-button
                round
                type="primary"
                ref="outPut"
                class="button_common_search marginRight"
                @click="outPutClick()"
              >
                <i class="el-icon-download"></i
                >{{ $t("resource.REPORT.REPORT_OUT") }}
              </t-button>
            </t-col>
          </t-row>
          <t-row>
            <t-table
              :data="supplierList"
              tooltip-effect="dark"
              style="width: 100%"
              header-cell-class-name="bg-default"
              :max-height="maxheight"
              highlight-current-row
              border
            >
              <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ -->
              <!-- <t-table-column
                v-if="supplierList.length"
                width="180"
                class-name="cell_txt_left"
                prop="supAbbreviation"
                :label="$t('resource.COMMON_CONSTANT.SUPPLIER')"
              >
              </t-table-column> -->
              <t-table-column
                v-if="supplierList.length"
                width="180"
                class-name="cell_txt_left"
                prop="supAbbreviation"
                :label="$t('resource.COMMON_CONSTANT.SUPPLIER')"
                :fixed="true"
              >
              </t-table-column>
              <!-- UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ -->

              <!-- <t-table-column
                v-for="(column, index) in columnList"
                :key="index"
                :label="column.month + ':11' + column.title"
                width="120"
                class-name="cell_txt_right"
                ><template #default="scope">
                  <span>{{
                    getCellOrderAmount(scope.row.supCode, column)
                  }}</span>
                </template>
              </t-table-column> -->

              <t-table-column
                v-for="(column, index) in columns"
                :key="index"
                :label="column.label"
              >
                <template v-if="column.children && column.children.length > 0">
                  <t-table-column
                    v-for="(columnSon, indexSon) in column.children"
                    :key="indexSon"
                    :label="columnSon.label"
                    :prop="columnSon.prop"
                    :class-name="columnSon.class"
                    :width="columnSon.width"
                  >
                    <template #default="scope">
                      <span>{{
                        getCellOrderAmount(scope.row.supCode, columnSon)
                      }}</span>
                    </template>
                  </t-table-column>
                  <!-- :prop="columnSon.prop" -->
                </template>
              </t-table-column>
            </t-table>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { t } from "@/locales";
import { outputExcelToZip } from "@/services/common";
import { SearchAnnualOrdersData } from "@/services/cusMOrderAmountReport";
import { formatStringToCurrency } from "@/utils/comFunction";
import { Message } from "@tellus/component";

export default {
  data() {
    return {
      //一覧高
      maxheight: window.innerHeight - 140,
      //期間年度
      yearList: [],
      //期間月度
      monthList: [],
      //期間値
      period: {
        startYear: "",
        startMonth: "",
        endYear: "",
        endMonth: "",
      },
      //期間月度
      periodMonthList: [],
      //月度差
      monthsDiff: 0,
      //仕入先データ
      supplierList: [],
      //columnList: [],
      columns: [],

      // 年間発注実績データ
      annualOrdersList: [],
      showFlag: false,
    };
  },

  mounted() {
    this.Init();

    this.$nextTick(() => {
      this.maxheight = document.body.clientHeight - 140;
    });
  },

  computed: {},

  methods: {
    // 初期化
    Init() {
      this.showFlag = true;
      //システム日
      var systemDate = new Date();
      //システム年
      var systemYear = systemDate.getFullYear();
      //システム月
      var systemMonth = systemDate.getMonth();

      //年度リスト
      for (let year = 2024; year <= systemYear + 1; year++) {
        this.yearList.push({
          value: year,
          label: year + t("resource.CUS_M_ORDER_AMOUNT.YEAR"),
        });
      }

      //月度リスト
      for (let month = 1; month <= 12; month++) {
        this.monthList.push({
          value: month,
          label: month + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
        });
      }

      //期間の初期値
      //システム月
      if (systemMonth <= 3) {
        //開始年度
        this.period.startYear = systemYear - 1;
        //終了年度
        this.period.endYear = systemYear;
      } else {
        //開始年度
        this.period.startYear = systemYear;
        //終了年度
        this.period.endYear = systemYear + 1;
      }

      //開始月度
      this.period.startMonth = 4;
      //終了月度
      this.period.endMonth = 3;
      //検索
      this.searchClick();
    },

    // 検索
    searchClick() {
      //チェック
      //月度差
      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      // console.log("this.monthsDiff---" + this.monthsDiff);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"),
          null
        );
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"),
          null
        );
        return;
      }

      //年間発注実績データの検索
      SearchAnnualOrdersData({
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
      })
        .then((res) => {
          //初期化
          //this.columnList.length = 0;

          //仕入先データ
          this.supplierList = res.supplierList;

          // console.log(
          //   "this.supplierList---" + JSON.stringify(this.supplierList)
          // );

          //合計行
          this.supplierList.push({
            supCode: "***",
            supAbbreviation: t("resource.ACCEPT_ORDER.SUM"),
          });

          //発注担当
          let personListInit = res.personList;

          // console.log("personListInit---" + JSON.stringify(personListInit));

          //期間月度
          this.periodMonthList.length = 0;
          //開始年月
          let year = this.period.startYear;
          let month = this.period.startMonth;
          //月度値
          let monthValue;
          //年月
          let yearMonth;

          // 年間発注実績データ
          this.annualOrdersList = res.annualOrdersList;
          var objTmp = "[";
          for (let i = 0; i <= this.monthsDiff; i++) {
            if (parseInt(month) + i <= 12) {
              //月度値
              monthValue = parseInt(month) + i;
              //年月
              if (monthValue < 10) {
                yearMonth = year + "_0" + monthValue;
              } else {
                yearMonth = year + "_" + monthValue;
              }
            } else {
              //月度値
              monthValue = parseInt(month) + i - 12;
              //年月
              if (monthValue < 10) {
                yearMonth = year + 1 + "_0" + monthValue;
              } else {
                yearMonth = year + 1 + "_" + monthValue;
              }
            }

            var columnListTmp = [];

            objTmp = objTmp + '{"label":"' + monthValue + '月",';
            objTmp = objTmp + '"children":';

            personListInit.map((item) => {
              //同じ月度データ
              if (item.month == yearMonth) {
                //担当者の追加
                columnListTmp.push({
                  monthIndex: i + 1, //月番
                  //month: item.month, //月度
                  prop: item.month,
                  code: item.userCode, //担当者コード
                  label: item.userName, //担当者名
                  class: "cell_txt_right",
                  width: "120",
                });
              }
            });

            //小計列の追加
            columnListTmp.push({
              monthIndex: i + 1, //月番
              // month: yearMonth, //月度
              prop: yearMonth,
              code: "***",
              label: t("resource.ACCEPT_ORDER.AMOUNT_SUM"),
              class: "cell_txt_right",
              width: "120",
            });

            objTmp = objTmp + JSON.stringify(columnListTmp) + "},";
          }
          objTmp = objTmp.slice(0, -1);
          objTmp = objTmp + "]";

          //列（表示用）
          this.columns = JSON.parse(objTmp);

          this.showFlag = false;
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"), null);
        });
    },

    outPutClick() {
      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"),
          null
        );
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"),
          null
        );
        return;
      }

      this.showFlag = true;

      //期間月度
      let monthList = [];
      //開始年月
      let year = this.period.startYear;
      let month = this.period.startMonth;
      //月度値
      let monthValue;
      //年月
      let yearMonth;
      for (let i = 0; i <= this.monthsDiff; i++) {
        if (parseInt(month) + i <= 12) {
          //月度値
          monthValue = parseInt(month) + i;
          //年月
          if (monthValue < 10) {
            yearMonth = year + "_0" + monthValue;
          } else {
            yearMonth = year + "_" + monthValue;
          }
        } else {
          //月度値
          monthValue = parseInt(month) + i - 12;
          //年月
          if (monthValue < 10) {
            yearMonth = year + 1 + "_0" + monthValue;
          } else {
            yearMonth = year + 1 + "_" + monthValue;
          }
        }

        monthList.push({
          title: monthValue + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
          yearMonth: yearMonth,
        });
      }

      outputExcelToZip(httpApi.OutAnnualOrdersDataByExcel, {
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
        titleDtos: monthList,
      })
        .then((res) => {
          //検索
          this.searchClick();
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 発注金の取得
    getCellOrderAmount(supCode, column) {
      let amount = 0;
      //小計
      for (let i = 0; i < this.annualOrdersList.length; i++) {
        let item = this.annualOrdersList[i];
        if (supCode == item.supCode && column.code == item.userCode) {
          amount = item.dicAmount["amount" + column.monthIndex];
          return formatStringToCurrency(amount);
        }
      }

      return amount;
    },
  },
};
</script>
